import React from "react";
import { connect, ConnectedProps } from "react-redux";
import styled from "styled-components";
import { fadeIn } from "sweet-web/lib/animations";
import { colors } from "sweet-web/lib/styles";
import { RootState } from "sweet-web/redux";
import ChatControls from "./ChatControls";
import ManageBooking from "./ManageBooking";

const Wrapper = styled.div`
  height: 100%;
  border-left: 1px solid ${colors.lightGray};
  min-width: 240px;
  ${fadeIn}
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  @media screen and (max-width: 600px) {
    /* mobile styling */
    display: none;
  }
`;

type Props = ConnectedProps<typeof connector>;

const ChatBooking: React.FC<Props> = props => {
  return (
    <Wrapper>
      <ManageBooking />
      <ChatControls />
    </Wrapper>
  );
};

const mapState = (state: RootState) => {
  return {};
};
const connector = connect(mapState);

export default connector(ChatBooking);
